const ErrorMessage = ({
  id,
  message,
}: {
  id?: string;
  message: string | undefined;
}) => (
  <span id={id} className="text-red-500 text-[10px] lg:text-xs">
    {message}
  </span>
);

export default ErrorMessage;
